import { useEffect, useState } from "react";
import NavBar from "../layout/NavBar";
import axios from "axios";

/*-----Hoja de estilo-----*/
import "../styles/services.css";

/*-----Iconos-----*/
import {
  MdLocalAtm,
  MdArrowBackIosNew,
  MdOutlineWifiPassword,
  MdOutlinePowerOff,
  MdOutlineWifiOff,
  MdNetworkCheck,
  MdStore,
  MdOutlineFactory,
} from "react-icons/md";
import { SiGoogleplay } from "react-icons/si";
import { FaChevronRight, FaWifi } from "react-icons/fa";
import { RiMedalLine } from "react-icons/ri";
import { IoInfiniteSharp } from "react-icons/io5";
import { IoMdCalendar } from "react-icons/io";
import { GoTag } from "react-icons/go";
import { TbCalendarTime, TbAlertTriangleFilled } from "react-icons/tb";
import { useNavigate } from 'react-router-dom';
import { AiOutlineGlobal } from "react-icons/ai";


const Services = ({ data, setSelectedServ, handleBack, capitalize, available }) => {
  const navigate = useNavigate();


  return (
    <div
      className={`contenServiciosGlobal ${data?.estado === "SUSPENDIDO" ? "suspend" : ""
        }`}
    >
      {data?.estado === "SUSPENDIDO" && (
        <>
          <div className="contenInformacion">
            <div className="infoTitulo">
              <TbAlertTriangleFilled className="iconAlert" />
              Atención
            </div>
            <div className="infoContenido">
              Su servicio se encuentra actualmente suspendido, recuerde siempre
              realizar los pagos de manuera puntual, antes de su fecha de corte,
              para disfrutar de su servicio sin interrupciones.
            </div>
          </div>
          <hr className="division" />
        </>
      )}
      <div className="contenServicios suspend">
        <div
          className={`volver ${data?.estado === "ACTIVO"
            ? "blue-b-l"
            : data?.estado === "RETIRADO"
              ? "red-b-l"
              : data?.estado === "POR RETIRAR"
                ? "orange-b-l"
                : data?.estado === "SUSPENDIDO"
                  ? "yellow-b-l"
                  : data?.estado === "TRANSFERIDO"
                    ? "gray-b-l"
                    : data?.estado === "EXONERADO"
                      ? "black-b-l"
                      : ""
            }`}
          onClick={() => {
            handleBack();
          }}
        >
          <MdArrowBackIosNew />
          <span>Volver</span>
        </div>
        <div
          className={`detalles ${data?.estado === "ACTIVO"
            ? "blue-b"
            : data?.estado === "RETIRADO"
              ? "red-b"
              : data?.estado === "POR RETIRAR"
                ? "orange-b"
                : data?.estado === "SUSPENDIDO"
                  ? "yellow-b"
                  : data?.estado === "TRANSFERIDO"
                    ? "gray-b"
                    : data?.estado === "EXONERADO"
                      ? "black-b"
                      : ""
            }`}
        >
          <div className="tituloDetalles">
            <span>Detalles del Servicio</span>
            <div
              className={`item ${data?.estado === "ACTIVO"
                ? "blue-c"
                : data?.estado === "RETIRADO"
                  ? "red-c"
                  : data?.estado === "POR RETIRAR"
                    ? "orange-c"
                    : data?.estado === "SUSPENDIDO"
                      ? "yellow-c"
                      : data?.estado === "TRANSFERIDO"
                        ? "gray-c"
                        : data?.estado === "EXONERADO"
                          ? "black-c"
                          : ""
                }`}
            >
              {data?.letter}
            </div>
          </div>
          <div className="detallesDireccion">
            <b>Dirección:</b> {data?.zona_estado?.valor},{" "}
            <b>{data?.ciudad2?.valor},</b> {data?.zona?.valor},{" "}
            {data?.dir_calle}, {data?.dir_referencia}.
          </div>
        </div>
        <div
          className={`estado ${data?.estado === "ACTIVO"
            ? "blue-b"
            : data?.estado === "RETIRADO"
              ? "red-b"
              : data?.estado === "POR RETIRAR"
                ? "orange-b"
                : data?.estado === "SUSPENDIDO"
                  ? "yellow-b"
                  : data?.estado === "TRANSFERIDO"
                    ? "gray-b"
                    : data?.estado === "EXONERADO"
                      ? "black-b"
                      : ""
            }`}
        >
          Estado
          <div className="estadoServ">
            {capitalize(data.estado)}
            <span>
              {data.estado === "ACTIVO" ? (
                <FaWifi />
              ) : data.estado === "SUSPENDIDO" ? (
                <MdOutlineWifiPassword />
              ) : data.estado === "RETIRADO" ? (
                <MdOutlinePowerOff />
              ) : data.estado === "POR RETIRAR" ? (
                <MdOutlineWifiOff />
              ) : data.estado === "EXONERADO" ? (
                <RiMedalLine />
              ) : data.estado === "TRANSFERIDO" ? (
                <MdNetworkCheck />
              ) : null}
            </span>
          </div>
        </div>
        {data.estado !== "TRANSFERIDO" && (
          <div
            className={`infoServ ${data?.estado === "ACTIVO"
              ? "blue-b-l"
              : data?.estado === "RETIRADO"
                ? "red-b-l"
                : data?.estado === "POR RETIRAR"
                  ? "orange-b-l"
                  : data?.estado === "SUSPENDIDO"
                    ? "yellow-b-l"
                    : data?.estado === "TRANSFERIDO"
                      ? "gray-b-l"
                      : data?.estado === "EXONERADO"
                        ? "black-b-l"
                        : ""
              }`}
          >
            <div className="servLim">
              <IoInfiniteSharp className="iconInfi" />
              Servicio ilimitado
            </div>
            {data?.tipo_servicio === "Pyme" && (
              <div className="servPlan mb-3">
                <div className="servPlanItem">
                  <b>Plan</b>
                  <div className="planCosto">
                    <b>
                      {data?.plan?.nombre}
                    </b>
                  </div>
                </div>
              </div>
            )}
            <div className="servPlan">
              <div className="servPlanItem">
                <b>Tipo de servicio</b>
                <div className="planCosto" style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                  <b>{data?.tipo_servicio}</b>
                  {data?.tipo_servicio == "Pyme" ? (
                    <MdStore />
                  ) : data?.tipo_servicio == "Corporativo" ? (
                    <MdOutlineFactory />
                  ) : (
                    <AiOutlineGlobal />
                  )}
                </div>
              </div>
            </div>
            {data?.datos_tecnicos?.bajada_fo &&
              <div
                className={`servPlan ${data?.estado === "SUSPENDIDO" ? "yellow-y-c" : ""
                  }`}
              >
                <div
                  className={`servPlanItem ${data?.estado === "SUSPENDIDO" ? "yellow-y-c" : ""
                    }`}
                >
                  <b>{data?.datos_tecnicos?.bajada_fo && "Fibra contratado"}</b>
                  <div className="planCosto">
                    <b>{data?.datos_tecnicos?.bajada_fo} Mbps</b>
                    <MdNetworkCheck className="iconPlan" />
                  </div>
                </div>
              </div>}
            {data?.datos_tecnicos?.bajada_fo &&
              <div
                className={`mt-3 servPlan ${data?.estado === "SUSPENDIDO" ? "yellow-y-c" : ""
                  }`}
              >
                <div
                  className={`servPlanItem ${data?.estado === "SUSPENDIDO" ? "yellow-y-c" : ""
                    }`}
                >
                  <b>{data?.datos_tecnicos?.bajada_fo && "Radio enlace contratado"}</b>
                  <div className="planCosto">
                    <b>{data?.datos_tecnicos?.bajada_re} Mbps</b>
                    <MdNetworkCheck className="iconPlan" />
                  </div>
                </div>
              </div>}
            {data?.plan?.subida &&
              <div
                className={`mt-3 servPlan ${data?.estado === "SUSPENDIDO" ? "yellow-y-c" : ""
                  }`}
              >
                <div
                  className={`servPlanItem ${data?.estado === "SUSPENDIDO" ? "yellow-y-c" : ""
                    }`}
                >
                  <b>Subida</b>
                  <div className="planCosto">
                    <b>{data?.plan?.subida} Mbps</b>
                    <MdNetworkCheck className="iconPlan" />
                  </div>
                </div>
              </div>}
            {data?.plan?.bajada &&
              <div
                className={`mt-3 servPlan ${data?.estado === "SUSPENDIDO" ? "yellow-y-c" : ""
                  }`}
              >
                <div
                  className={`servPlanItem ${data?.estado === "SUSPENDIDO" ? "yellow-y-c" : ""
                    }`}
                >
                  <b>Bajada</b>
                  <div className="planCosto">
                    <b>{data?.plan?.bajada} Mbps</b>
                    <MdNetworkCheck className="iconPlan" />
                  </div>
                </div>
              </div>}
            <div
              className={`mt-3 servPlan ${data?.estado === "SUSPENDIDO" ? "yellow-y-c" : ""
                }`}
            >
              <div
                className={`servPlanItem ${data?.estado === "SUSPENDIDO" ? "yellow-y-c" : ""
                  }`}
              >
              </div>
              <div className="servPlanItem">
                <b>Costo mensual</b>
                <div className="planCosto">
                  <b>{(data.tipo_servicio === "ISP" || data.tipo_servicio === "Corporativo") ? (data?.tarifa + " $") : (data.tipo_servicio === "Pyme" && data?.plan?.costo + " $")}</b>
                  <GoTag className="iconPlan" />
                </div>
              </div>
            </div>
          </div>
        )}
        {/*  {data.estado !== "RETIRADO" &&
          data.estado !== "EXONERADO" &&
          data.estado !== "TRANSFERIDO" && (
            <div className="saldoActualServ">
              <b
                className={`saldoTitulo ${
                  data?.estado === "ACTIVO"
                    ? "blue-c"
                    : data?.estado === "RETIRADO"
                    ? "red-c"
                    : data?.estado === "POR RETIRAR"
                    ? "orange-c"
                    : data?.estado === "SUSPENDIDO"
                    ? ""
                    : data?.estado === "TRANSFERIDO"
                    ? "gray-c"
                    : data?.estado === "EXONERADO"
                    ? "black-c"
                    : ""
                }`}
              >
                Saldo actual
              </b>
              <div
                className={`saldoDetalles ${
                  data?.estado === "ACTIVO"
                    ? "blue-c"
                    : data?.estado === "RETIRADO"
                    ? "red-c"
                    : data?.estado === "POR RETIRAR"
                    ? "orange-c"
                    : data?.estado === "SUSPENDIDO"
                    ? "yellow-y-c"
                    : data?.estado === "TRANSFERIDO"
                    ? "gray-c"
                    : data?.estado === "EXONERADO"
                    ? "black-c"
                    : ""
                }`}
              >
                <div className="saldoServ">
                  <b
                    className={`sald ${
                      data?.estado === "ACTIVO"
                        ? "blue-c-b"
                        : data?.estado === "RETIRADO"
                        ? "red-c-b"
                        : data?.estado === "POR RETIRAR"
                        ? "orange-c-b"
                        : data?.estado === "SUSPENDIDO"
                        ? "yellow-c-b"
                        : data?.estado === "TRANSFERIDO"
                        ? "gray-c-b"
                        : data?.estado === "EXONERADO"
                        ? "black-c-b"
                        : ""
                    }`}
                  >
                    $0,00
                  </b>
                </div>
                <div
                  className={`servFechaItem1 ${
                    data?.estado === "SUSPENDIDO" ? "yellow-y-c" : ""
                  }`}
                >
                  <b>Fecha de su prox. pago</b>
                  <div className="servFecha">
                    <b></b>
                    <IoMdCalendar className="iconPlan" />
                  </div>
                </div>
                <div className="servFechaItem">
                  <b>Dia de corte del servicio</b>
                  <div className="servFecha">
                    <b>{data.dia_corte}</b>
                    <TbCalendarTime className="iconPlan" />
                  </div>
                </div>
              </div>
            </div>
          )} */}
      </div>
      {(data?.pending?.length > 0 || available?.allow_advance_payment) ? (
        <div
          className="botonPagarAbonar"
          onClick={() => {
            if (data?.pending?.length > 0) {
              navigate("/metodos", { state: { factura: true } });
            } else if (available?.allow_advance_payment) {
              navigate("/metodos", { state: { abonar: true } });
            }
          }}
        >
          <span>{data?.pending?.length > 0 ? "Pagar" : "Abonar"}</span>
        </div>
      ) : null}
    </div>
  );
};

export default Services;
